import { render, staticRenderFns } from "./CellRendererTags.vue?vue&type=template&id=10e24142&"
import script from "./CellRendererTags.vue?vue&type=script&lang=ts&"
export * from "./CellRendererTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports